import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./additional-resources.${locale}.json`));
